import { Author } from "@app/types";

type AuthorItemProps = {
  author: Author;
};

function AuthorItem({ author }: AuthorItemProps) {
  return (
    <div className="flex flex-col gap-2 items-center">
      <div className="size-[220px] rounded-full">
        <img
          className="size-[220px] rounded-full object-cover"
          src={author.thumbnail}
          alt=""
        />
      </div>
      <div className="font-[SVN-Gilroy] text-[#171A20] font-semibold text-lg">
        {author.fullName}
      </div>
    </div>
  );
}

export default AuthorItem;
